module.exports = __webpack_public_path__ + "static/media/02.c7406939.png";